import { render, staticRenderFns } from "./ModalExcluirItemRepasse.vue?vue&type=template&id=6e1593ea"
import script from "./ModalExcluirItemRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalExcluirItemRepasse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports